export const zIndex = {
  bottomNavBar: 997,
  topBar: 998,
  drawerSidebar: 999,
};
